import Cookie from 'js-cookie'

import { DEFAULT_LANGUAGE, LANGUAGE_COOKIE_NAME } from 'localization/enums/LocalizationEnums'

export const getLocale = () => {
  const localeFromCookie = Cookie.get(LANGUAGE_COOKIE_NAME)

  return localeFromCookie || DEFAULT_LANGUAGE
}
